<app-admin-toast></app-admin-toast>
<div class="padding-component">
    <app-header [title]="'Documentos'"></app-header>
    <mat-tab-group>
        <mat-tab label="Tipos"><app-document-types-list></app-document-types-list></mat-tab>
        <mat-tab label="Empleados"><app-client-documents-list></app-client-documents-list></mat-tab>
        <mat-tab label="Vehículos"><app-car-documents-list></app-car-documents-list></mat-tab>
        <mat-tab label="Empresas"><app-company-documents-list></app-company-documents-list></mat-tab>
    </mat-tab-group>
</div>